"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClassName = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _DialogActions = _interopRequireDefault(require("@mui/material/DialogActions"));
var _useMediaQuery = _interopRequireDefault(require("@mui/material/useMediaQuery"));
var _classnames = _interopRequireDefault(require("../Dialog/classnames"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var styles = {
  "dialogActionsWrapper": "ztHb41",
  "default": "_5wE5ns",
  "stacked": "goW7-N"
};
var getClassName = exports.getClassName = function getClassName(_ref) {
  var className = _ref.className,
    variant = _ref.variant;
  return (0, _clsx["default"])(className, _classnames["default"].DIALOG_ACTIONS_WRAPPER, styles.dialogActionsWrapper, styles[variant]);
};
var DialogActions = function DialogActions(_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    variant = _ref2.variant;
  var isMobile = (0, _useMediaQuery["default"])('(max-width:640px)');
  var isStacked = variant === 'stacked';
  var fullWidth = isMobile || isStacked;
  var childrenWithFullWidth = _react["default"].Children.map(children, function (child) {
    return /*#__PURE__*/_react["default"].isValidElement(child) ? /*#__PURE__*/_react["default"].cloneElement(child, {
      fullWidth: fullWidth
    }) : child;
  });
  return /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], {
    className: getClassName({
      className: className,
      variant: variant
    })
  }, childrenWithFullWidth);
};
DialogActions.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  variant: _propTypes["default"].oneOf(['default', 'stacked'])
} : {};
DialogActions.defaultProps = {
  variant: 'default'
};
var _default = exports["default"] = DialogActions;